var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileIconOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 32,
    viewBox: "0 0 22 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33334 0C2.14001 0 0.333344 1.80667 0.333344 4V28C0.333344 30.1933 2.14001 32 4.33334 32H17.6667C19.86 32 21.6667 30.1933 21.6667 28V4C21.6667 1.80667 19.86 0 17.6667 0H4.33334ZM4.33334 2.66667H17.6667C18.4067 2.66667 19 3.26 19 4V28C19 28.74 18.4067 29.3333 17.6667 29.3333H4.33334C3.59334 29.3333 3.00001 28.74 3.00001 28V4C3.00001 3.26 3.59334 2.66667 4.33334 2.66667ZM11 25.3333C10.2667 25.3333 9.66668 25.9333 9.66668 26.6667C9.66668 27.4 10.2667 28 11 28C11.7333 28 12.3333 27.4 12.3333 26.6667C12.3333 25.9333 11.7333 25.3333 11 25.3333Z",
    fill: "#00A9A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIconOutlined);
export default __webpack_public_path__ + "static/media/MobileIconOutlined.6acf83250c7f7def8fd14aca3aa7ec88.svg";
export { ForwardRef as ReactComponent };